import React, { useContext } from 'react';
import { Environment, Network, QueryResponseCache, RecordSource, Store } from 'relay-runtime';
import 'isomorphic-fetch';
import { httpHeaders } from "./constants";
const oneMinute = 60 * 1000;

function fetchQueryWithOptions() {
  let {
    cache,
    authToken,
    host
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function fetchQuery(operation, variables, cacheConfig) {
    const queryID = operation.text;
    const isMutation = operation.operationKind === 'mutation';
    const isQuery = operation.operationKind === 'query';
    const forceFetch = cacheConfig && cacheConfig.force; // Try to get data from cache on queries

    const fromCache = cache.get(queryID, variables);

    if (isQuery && fromCache !== null && !forceFetch) {
      return fromCache;
    }

    const headers = {
      'Content-Type': 'application/json'
    };

    if (authToken) {
      headers.Authorization = "Bearer ".concat(authToken);
    }

    if (window._sessionId) {
      headers[httpHeaders.sessionId] = window._sessionId;
    } // Otherwise, fetch data from server


    return fetch((host || '') + '/graphql', {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({
        query: operation.text,
        variables
      })
    }).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        console.log(operation.name, response.status);
        cache.clear();
        return {
          data: {}
        };
      }
    }).then(json => {
      if (json.errors && json.errors.length > 0) {
        console.log(json.errors);
        throw new Error(json.errors[0].message);
      } // Update cache on queries


      if (isQuery && json) {
        cache.set(queryID, variables, json);
      } // Clear cache on mutations


      if (isMutation) {
        cache.clear();
      }

      return json;
    });
  };
}

export function createCache() {
  return new QueryResponseCache({
    size: 250,
    ttl: oneMinute
  });
}
export function createEnvironment(_ref) {
  let {
    cache,
    authToken,
    host
  } = _ref;
  return new Environment({
    network: Network.create(fetchQueryWithOptions({
      cache,
      authToken,
      host
    })),
    store: new Store(new RecordSource())
  });
}
export function createContext() {
  let {
    authToken,
    host
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const cache = createCache();
  return {
    cache,
    environment: createEnvironment({
      cache,
      authToken,
      host
    }),
    host: host,
    createContext
  };
}
export const context = createContext();
export const Context = /*#__PURE__*/React.createContext(context);
export function useRelayContext() {
  const relayContext = useContext(Context);
  return relayContext;
}